document.addEventListener('DOMContentLoaded', () => {
  productJsInit();
});

function productJsInit() {
  document.querySelectorAll('script[type="application/json"][data-product-key]').forEach(initVariants);
}

function initVariants(script) {
  const productKey = script.dataset.productKey;
  if (!productKey) return;

  const variantData = JSON.parse(script.textContent);

  // Regroupe tous les éléments DOM filtrés par productKey
  const elements = {
    emblaContainer: document.querySelector(`[data-embla-id][data-product-key="${productKey}"]`),
    idInputs: document.querySelectorAll(`[data-product-variant-id][data-product-key="${productKey}"]`),
    actionButtons: document.querySelectorAll(`[data-product-add-to-cart][data-product-key="${productKey}"]`),
    actionTexts: document.querySelectorAll(`[data-product-add-to-cart-text][data-product-key="${productKey}"]`),
    priceDisplays: document.querySelectorAll(`[data-product-price][data-product-key="${productKey}"]`),
    variantInputs: document.querySelectorAll(`[data-product-variant][data-product-key="${productKey}"]`),
  };

  function getSelectedOptions() {
    const optionNames = [...new Set([...elements.variantInputs].map((i) => i.name))];
    return optionNames.map((name) => {
      const checked = document.querySelector(
        `[data-product-variant][data-product-key="${productKey}"][name="${name}"]:checked`,
      );
      return checked ? checked.value : null;
    });
  }

  function syncRadios(changedInput) {
    document
      .querySelectorAll(
        `input[name="${changedInput.name}"][value="${changedInput.value}"][data-product-variant][data-product-key="${productKey}"]`,
      )
      .forEach((input) => (input.checked = true));
  }

  function updateVariant() {
    const selectedOptions = getSelectedOptions();
    const matchedVariant = variantData.find((v) => v.options.every((opt, i) => opt === selectedOptions[i]));
    
    if (!matchedVariant) {
      elements.idInputs.forEach((input) => {
        input.value = '';
      });
    
      elements.actionButtons.forEach((button) => {
        button.disabled = true;
      });
    
      elements.actionTexts.forEach((text) => {
        text.textContent = window.variantStrings.unavailable;
      });
    
      elements.priceDisplays.forEach((element) => {
        element.textContent = '—';
      });
    
      return;
    }

    // Mise à jour ID, prix et boutons
    elements.idInputs.forEach(input => {
      input.value = matchedVariant.id;
    });
    

    const formattedPrice = formatMoney(matchedVariant.price);
    elements.priceDisplays.forEach((el) => (el.innerHTML = formattedPrice));

    elements.actionButtons.forEach((btn) => (btn.disabled = !matchedVariant.available));
    elements.actionTexts.forEach((text) => {
      text.innerText = matchedVariant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
    });

    // Galerie
    const mediaId = matchedVariant.featured_media?.id || matchedVariant.featured_image?.id;
    if (mediaId && elements.emblaContainer) updateGallery(mediaId, elements.emblaContainer);
  }

  // Écouteurs
  elements.variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      syncRadios(input);
      updateVariant();
    });
  });
}

// ------------------------
// Fonctions utilitaires
// ------------------------

function updateGallery(mediaId, emblaContainer) {
  const emblaProduct = window.emblaInstances.getById(emblaContainer.dataset.emblaId);
  if (!mediaId || !emblaProduct) return;

  const slides = Array.from(emblaContainer.querySelectorAll('.embla__slide'));
  const index = slides.findIndex((slide) => slide.dataset.mediaId == mediaId);
  if (index !== -1) emblaProduct.scrollTo(index);
}

function formatMoney(cents, format = window.money_format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const value = parseInt(cents, 10) / 100;

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = format.match(placeholderRegex);
  if (!match) return value.toFixed(2);

  const formatType = match[1];
  const formatMap = {
    amount: value.toFixed(2),
    amount_no_decimals: Math.round(value).toString(),
    amount_with_comma_separator: value.toFixed(2).replace('.', ','),
    amount_no_decimals_with_comma_separator: Math.round(value).toString().replace('.', ','),
    amount_with_space_separator: value
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
    amount_no_decimals_with_space_separator: Math.round(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
  };

  return format.replace(placeholderRegex, formatMap[formatType] || value.toFixed(2));
}
